import { Modal, Table } from "antd";
import { memo } from "react";
import { useSelector } from "react-redux";
import { formatDateToDDMMYYYY } from "utils/CommonFunctions";

const columns = [
  {
    title: "Sr. No.",
    dataIndex: "srNo",
    key: "srNo",
    render: (text, data, index) => index + 1,
  },
  {
    title: "Days",
    dataIndex: "days",
    key: "days",
  },
  {
    title: "No. of Embryos",
    dataIndex: "no_of_embryos",
    key: "no_of_embryos",
  },
  {
    title: "No. of Oocytes Fertilizes",
    dataIndex: "no_of_oocytes_fertilized",
    key: "no_of_oocytes_fertilized",
  },
  {
    title: "Grade of Embryos",
    dataIndex: "grade_embryos",
    key: "grade_embryos",
  },
];
const columnsForEmbryoFrozenDetails = [
  {
    title: "Sr. No.",
    dataIndex: "srNo",
    key: "srNo",
    render: (text, data, index) => index + 1,
  },
  {
    title: "Straw No",
    dataIndex: "straw_no",
    key: "straw_no",
  },
  {
    title: "Embryo Days",
    dataIndex: "embryo_days",
    key: "embryo_days",
  },
  {
    title: "No Of Embryo",
    dataIndex: "no_of_embryo",
    key: "no_of_embryo",
  },
  {
    title: "Grade",
    dataIndex: "grade",
    key: "grade",
  },
  {
    title: "Score",
    dataIndex: "score",
    key: "score",
  },
  {
    title: "Vitrification Id",
    dataIndex: "vitrification_id",
    key: "vitrification_id",
  },
  {
    title: "PGTA Report",
    dataIndex: "pgta_report",
    key: "pgta_report",
  },
];

const DischargeCardModal = ({ isOpen, onClose }) => {
  const theme = localStorage.getItem("default-theme");

  const { activePatientJourneyModuleDetails } = useSelector(
    ({ dashboard }) => dashboard
  );

  return (
    <>
      <Modal
        centered
        open={isOpen}
        title="Discharge Card Detail"
        className={`patient-registration-modal theme-${theme}`}
        maskClosable={false}
        onCancel={() => onClose()}
        width={860}
      >
        <div className="modal-details">
          <div className="modal-content-details">
            <div className="details">
              <div className="details-table">
                <div>Patient ID </div>
                <div>{activePatientJourneyModuleDetails?.patient_id}</div>
                <div>Patient Name</div>
                <div>
                  {activePatientJourneyModuleDetails?.patient_full_name}
                </div>
                <div>Age</div>
                <div>{activePatientJourneyModuleDetails?.patient_dob}</div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">Patient Details</div>
              <div className="details-table">
                <div>LMP</div>
                <div>
                  {activePatientJourneyModuleDetails?.last_menstrual_period}
                </div>
                <div>M.S</div>
                <div>{activePatientJourneyModuleDetails?.married_since}</div>
                <div>OPU</div>
                <div>{activePatientJourneyModuleDetails?.pick_up_date}</div>
                <div>DOD</div>
                <div>
                  {activePatientJourneyModuleDetails?.dod
                    ? formatDateToDDMMYYYY(
                        activePatientJourneyModuleDetails?.dod
                      )
                    : ""}
                </div>
                <div>ETDOA</div>
                <div>
                  {activePatientJourneyModuleDetails?.etdoa
                    ? formatDateToDDMMYYYY(
                        activePatientJourneyModuleDetails?.etdoa
                      )
                    : ""}
                </div>
                <div>ETDOD</div>
                <div>
                  {activePatientJourneyModuleDetails?.etdod
                    ? formatDateToDDMMYYYY(
                        activePatientJourneyModuleDetails?.etdod
                      )
                    : ""}
                </div>
                <div>BDOA</div>
                <div>
                  {activePatientJourneyModuleDetails?.bdoa
                    ? formatDateToDDMMYYYY(
                        activePatientJourneyModuleDetails?.bdoa
                      )
                    : ""}
                </div>
                <div>BDOD</div>
                <div>
                  {activePatientJourneyModuleDetails?.bdod
                    ? formatDateToDDMMYYYY(
                        activePatientJourneyModuleDetails?.bdod
                      )
                    : ""}
                </div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">Other Details</div>
              <div className="details-table">
                <div>Diagnosis</div>
                <div>{activePatientJourneyModuleDetails?.diagnosis}</div>
                <div>Procedure</div>
                <div>{activePatientJourneyModuleDetails?.procedure}</div>
                <div>Endometrium</div>
                <div>{activePatientJourneyModuleDetails?.endometrium}</div>
                <div>Hormones Given</div>
                <div>{activePatientJourneyModuleDetails?.hormones_given}</div>
                <div>Rupture Given With</div>
                <div>
                  {activePatientJourneyModuleDetails?.rupture_given_with}
                </div>
                <div>Oocytes Retrieved</div>
                <div>
                  {activePatientJourneyModuleDetails?.oocytes_retrieved}
                </div>
                <div>PESA / TESA Done</div>
                <div>{activePatientJourneyModuleDetails?.pesa_tesa_done}</div>
                <div>ICSI Done With</div>
                <div>{activePatientJourneyModuleDetails?.icsi_done_with}</div>
                <div>With Consent On</div>
                <div>
                  {activePatientJourneyModuleDetails?.with_consent_on
                    ? formatDateToDDMMYYYY(
                        activePatientJourneyModuleDetails?.with_consent_on
                      )
                    : ""}
                </div>
                <div>Count</div>
                <div>{activePatientJourneyModuleDetails?.count}</div>
                <div>Motility</div>
                <div>{activePatientJourneyModuleDetails?.motility}</div>
                <div>Morphology</div>
                <div>{activePatientJourneyModuleDetails?.morphology}</div>
                <div>Cleaved</div>
                <div>{activePatientJourneyModuleDetails?.cleaved}</div>
                <div>Fertilized</div>
                <div>{activePatientJourneyModuleDetails?.fertilized}</div>
                <div>Embryos Transferred</div>
                <div>
                  {activePatientJourneyModuleDetails?.embryos_transferred}
                </div>
                <div>Embryos Transferred Others</div>
                <div>
                  {activePatientJourneyModuleDetails?.embryos_transferred_other}
                </div>
                <div>No. of Embryo Frozen</div>
                <div>
                  {activePatientJourneyModuleDetails?.no_of_embryo_frozen}
                </div>
                <div>Embryo Frozen Date</div>
                <div>
                  {activePatientJourneyModuleDetails?.embryo_frozen_date
                    ? formatDateToDDMMYYYY(
                        activePatientJourneyModuleDetails?.embryo_frozen_date
                      )
                    : ""}
                </div>
                <div>Remaining Frozen Embryos</div>
                <div>
                  {activePatientJourneyModuleDetails?.remaining_frozen_embryos}
                </div>
                <div>Catheter</div>
                <div>{activePatientJourneyModuleDetails?.catheter}</div>
                <div>Media</div>
                <div>{activePatientJourneyModuleDetails?.media}</div>
                <div>IVF ID</div>
                <div>{activePatientJourneyModuleDetails?.ivf_flow_id}</div>
                <div>Embryologist</div>
                <div>{activePatientJourneyModuleDetails?.embryologistName}</div>
              </div>
            </div>
            {/* <div className="details">
              <div className="table-title">
                No. of Embryos
              </div>
              <div className="details-table">
                <div>Days</div>
                <div>{activePatientJourneyModuleDetails?.days}</div>
                <div>No. of Embryos</div>
                <div>{activePatientJourneyModuleDetails?.no_of_embryos}</div>
                <div>No. of Oocytes Fertilized</div>
                <div>{activePatientJourneyModuleDetails?.no_of_oocytes_fertilized}</div>
                <div>Grade of Embryos</div>
                <div>{activePatientJourneyModuleDetails?.grade_embryos}</div>
              </div>
            </div> */}
            {/* <div className="details">
              <div className="table-title">
                Embryo Frozen Details
              </div>
              <div className="details-table">
                <div>Straw No</div>
                <div>{activePatientJourneyModuleDetails?.straw_no}</div>
                <div>Embryo Days</div>
                <div>{activePatientJourneyModuleDetails?.embryo_days}</div>
                <div>No Of Embryo</div>
                <div>{activePatientJourneyModuleDetails?.no_of_embryo}</div>
                <div>Grade</div>
                <div>{activePatientJourneyModuleDetails?.grade}</div>
                <div>Score</div>
                <div>{activePatientJourneyModuleDetails?.score}</div>
                <div>Vitrification Id</div>
                <div>{activePatientJourneyModuleDetails?.vitrification_id}</div>
                <div>PGTA Report</div>
                <div>{activePatientJourneyModuleDetails?.pgta_report}</div>
                <div>IVF ID for Frozen Detail</div>
                <div>{activePatientJourneyModuleDetails?.embryo_frozen_ivf_flow_id}</div>
                <div>Embryo Frozen Notes</div>
                <div>{activePatientJourneyModuleDetails?.embryo_frozen_notes}</div>
              </div>
            </div> */}
            <div className="details">
              <div className="table-title">Other Details</div>
              <div className="details-table">
                <div>To Get 3cc of Blood in Plain bulb for Sr-Beta HCG on</div>
                <div>{activePatientJourneyModuleDetails?.hcg_date}</div>
                <div>Notes</div>
                <div>{activePatientJourneyModuleDetails?.notes}</div>
              </div>
            </div>
          </div>
          <div className="cmn_table_wrap table_wrapper mb-2">
            <h3 className="mt-3">No. of Embryos</h3>
            <Table
              columns={columns}
              dataSource={
                activePatientJourneyModuleDetails?.discharge_card_table
              }
              pagination={false}
            />
          </div>
          <div className="cmn_table_wrap table_wrapper mb-2">
            <h3 className="mt-3">Embryo Frozen Details</h3>
            <Table
              columns={columnsForEmbryoFrozenDetails}
              dataSource={
                activePatientJourneyModuleDetails?.embryo_frozen_table
              }
              pagination={false}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default memo(DischargeCardModal);
